/**
 * User: Aaron Horton
 * Date: 3/12/15
 * Time: 6:13 PM
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var endpoints = require('dibs-endpoints');

module.exports = SoaCollection.extend({
    fetchByZip: function (zipCode, country) {
        return this.fetch({
            url: endpoints.zipCode(),
            data: {
                zipCode: zipCode,
                country: country
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/Addresses.js
// module id = 1463
// module chunks = 64